(function () {
  if (window.matchMedia('(min-width: 1000px)').matches) return;

  function findInlineAtc() {
    return (
      document.querySelector('product-form button[type="submit"]') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      document.querySelector('buy-buttons button[type="submit"]')
    );
  }
  function findVariantPicker() {
    return document.querySelector('variant-picker, .variant-picker');
  }
  function findPriceDisplay() {
    return document.querySelector(
      '.price-item--sale, .price__current, .price-item, [class*="price-item"]'
    );
  }
  function findBackInStock() {
    return document.querySelector('[data-sb-bis][data-state="ready"]');
  }

  // The sticky bar lives in a custom-liquid block, and "liquid" is in theme.js's
  // partial-rerender allow-list -- so #sbStickyAtcBtn is REPLACED on every variant
  // change. Listeners must be delegated and elements looked up at call time, or the
  // bar goes dead after the first colour switch (on mobile it is the only CTA).
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#sbStickyAtcBtn')) return;
    e.preventDefault();

    var current = findInlineAtc();
    if (current && !current.disabled) {
      current.click();
      return;
    }

    // Sold out: send them to the notify-me form rather than the variant picker.
    var bis = findBackInStock();
    if (bis) {
      bis.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var email = bis.querySelector('[data-sb-bis-email]');
      // Delay the focus so the virtual keyboard does not abort the smooth scroll.
      if (email) {
        setTimeout(function () {
          email.focus({ preventScroll: true });
        }, 350);
      }
      return;
    }

    var picker = findVariantPicker();
    if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  // While the notify-me card is on screen the sticky bar is an exact duplicate of the
  // button inside it - two identical black CTAs stacked. Suppress the bar whenever the
  // card is in view and bring it back once the card scrolls away, so the bar still does
  // its actual job (a way back to the form from further down the page).
  var bisObserver = null;

  function watchBackInStock() {
    var bar = document.getElementById('sbStickyAtc');
    if (!bar) return;

    if (bisObserver) {
      bisObserver.disconnect();
      bisObserver = null;
    }

    var card = findBackInStock();
    if (!card || !('IntersectionObserver' in window)) {
      bar.classList.remove('sb-sticky-atc--suppressed');
      return;
    }

    bisObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('sb-sticky-atc--suppressed', entry.isIntersecting);
        });
      },
      // Fire slightly before the card is flush with the bar, so they never overlap.
      { rootMargin: '0px 0px -80px 0px', threshold: 0 }
    );
    bisObserver.observe(card);
  }

  function init() {
    if (!document.getElementById('sbStickyAtcBtn')) return;

    var tries = 0;
    function trySync() {
      var labelEl = document.getElementById('sbStickyAtcLabel');
      var priceEl = document.getElementById('sbStickyAtcPrice');
      var inline = findInlineAtc();
      if (inline) {
        var bis = findBackInStock();
        // Sold out with a notify-me form present: "Benachrichtige mich", not "Ausverkauft".
        var t =
          inline.disabled && bis
            ? bis.getAttribute('data-sticky-label') || inline.textContent.trim()
            : inline.textContent.trim();
        if (t && labelEl) labelEl.textContent = t;
        var p = findPriceDisplay();
        if (p && priceEl) priceEl.textContent = p.textContent.trim();
      } else if (tries++ < 10) {
        setTimeout(trySync, 200);
      }
    }
    trySync();
    watchBackInStock();

    document.addEventListener(
      'variant:change',
      function () {
        // The buy-buttons block (and the card inside it) is replaced on every variant
        // change, so the old observed node is gone: re-target it.
        setTimeout(function () {
          trySync();
          watchBackInStock();
        }, 80);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
